import React, { useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import ArrowDownIcon from "../../assets/img/arrowDownIcon";
import { setAuction } from "../../redux/newRequest/newRequest.actions";

import {
  selectNewRequestAuctionList,
  selectNewRequestSelectedAuction,
} from "../../redux/newRequest/newRequest.selectors";
import Clock from "../clock/clock.component";
import { AuctionStyled } from "./auction.styles";

const Auction = ({
  second,
  selectNewRequestAuctionList,
  selectNewRequestSelectedAuction,

  setAuction,
}) => {
  console.log(selectNewRequestSelectedAuction);
  const [visible, setVisible] = useState(false);
  const handle_select_change = (e) => {
    const value = e.currentTarget.value;
    setAuction(value);
  };
  const showModal = () => {
    setVisible(true);
  };
  return (
    <div style={{width: "49%"}}>
      <AuctionStyled>
        {/* <button onClick={showModal}>sssss</button> */}
        <Clock visible={visible} setVisible={setVisible} />
        <select
          onChange={handle_select_change}
          name=""
          id=""
          className="input--custom font-weight-bold font-size--1 m-0"
          value={selectNewRequestSelectedAuction}
        >
          <option value="" disabled selected>
            زمان پیشنهادگیری
          </option>
          {selectNewRequestAuctionList &&
            selectNewRequestAuctionList?.map(({ caption, _id }) => (
              <option key={_id} value={_id}>
                {caption}
              </option>
            ))}
        </select>
        <div className="arrow-cont">
          <ArrowDownIcon color="#9F9F9F" size="20" />
        </div>
      </AuctionStyled>
      {!second && (
        <div className="text-muted">
          مدت زمانی است که شما به رانندگان اجازه می‌دهید قیمت مورد نظرشان را ثبت
          کنند. شما می‌توانید این زمان را تمدید کنید.
        </div>
      )}
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  selectNewRequestAuctionList: selectNewRequestAuctionList,
  selectNewRequestSelectedAuction: selectNewRequestSelectedAuction,
});

const mapDispatchToProps = (dispatch) => ({
  setAuction: (x) => dispatch(setAuction(x)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Auction);
